<template>
<div class="homes">
   <aboutStyle title="关于我们"></aboutStyle>
   <div class="centers">
      <ul class="ul-c" v-for="(item,index) in aboutList" :key="item">
        <li :class="index === activeIndex ? 'li-unselect-active  li-unselect':'li-unselect'" @click="selectLi(index)">{{item.aboutTitle}}</li>
    </ul>  
   </div>
   <div class="content" v-html="showContent">
   </div>
</div>
</template>
<script>
import aboutStyle from '@/components/aboutStyle.vue';
export default {
  components:{ aboutStyle},
  data(){
    return {
      urls:'/api/admin/about/select_page',
      title:'aboutTitle',
      content:'aboutContent',
      radio1:"上海",
      aboutList:[
      ],
      showContent:"",
      activeIndex:0

    }
  },
  created(){
    this.getAboutUs()
  },
  methods:{
    selectLi(index){
        this.activeIndex = index
        this.showContent = this.aboutList[index].aboutContent;
    },
    getAboutUs(){
      this.$api.get("/api/web/get_about_us_list").then((res) => {
          if(res.code != 1){
                  this.$message.error(res.message)
              }else{
                this.aboutList = res.response;
                if(this.aboutList.length > 0){
                  this.showContent = this.aboutList[0].aboutContent
                }
                console.log(this.aboutList)
              }
            }).catch((res) => {
              console.error(res)
            })
      }
  }
}
</script>
<style lang="less" scoped>
  .homes{
    height: calc(~"100% - 20px");
    margin-top: 20px;
    margin-bottom: 20px;
    
}
  .centers{
    display: flex;
    justify-items: center;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

.li-unselect{
  width: 85px;
  padding-left: 23px;
  padding-right: 23px;
  padding-top: 8px;
  padding-bottom: 8px;
  border: 1px solid #999999;
  border-radius: 50px;
  text-align: center;
  color: #999999;
  list-style: none;
  display: inline-block;
  margin-right: 80px;
  margin-left: 40px;
}
.ul-c{
  display:inline;
  white-space:nowrap;
}
.li-unselect-active{
  color: white;
  border: 1px solid transparent;
  background-color: #015DB7;
}
.content{
  margin-top: 26px;
  font-size: 15px;
}


</style>